export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11665.e18d9c53.jpg";